import { render, staticRenderFns } from "./customerPriceListEditor.vue?vue&type=template&id=7d4221f6&"
import script from "./customerPriceListEditor.vue?vue&type=script&lang=js&"
export * from "./customerPriceListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports